
export default {
    searchContainres(params) {
        let path = '/publisher/containers.search';
        params = params || {};
        params.fields = 'container.width,container.height,link.url,link.default,link.locales,link.image,link.thumbnail';
        return this.makeRequest(path, params);
    },

    searchContainreLocales(params) {
        let path = '/publisher/containers.getLocales';
        params = params || {};
        return this.makeRequest(path, params);
    }
};